module.exports = __webpack_public_path__ + "static/media/icon.91b3b163.png";